import { render, staticRenderFns } from "./menuColumnGroups.vue?vue&type=template&id=199c1908&scoped=true&"
import script from "./menuColumnGroups.vue?vue&type=script&lang=js&"
export * from "./menuColumnGroups.vue?vue&type=script&lang=js&"
import style0 from "./menuColumnGroups.vue?vue&type=style&index=0&id=199c1908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c1908",
  null
  
)

export default component.exports